module.exports = __webpack_public_path__ + "img/svg/game-header-footer.6d9e573c22cc341e4fab89d0753bc0e4.svg";